import { useAppSelector } from "../redux";

export const useAspects = () => {
  const apsects = useAppSelector(state => state.product.design_detail.data.aspects)
  return Object.values(apsects || {})
}